import { ValueOf } from "@/lib/utils";
import { create } from "@/lib/zustand";

export const DeepAnalysisType = {
  VOC_SEARCH: "voc_search",
  CHAT: "chat",
} as const;

export type DeepAnalysisType = ValueOf<typeof DeepAnalysisType>;

interface DeepAnalysisStore {
  isDeepAnalysisModalOpen: boolean;
  deepAnalysisType: DeepAnalysisType | undefined;
  setIsDeepAnalysisModalOpen: (isOpen: boolean) => void;
  setDeepAnalysisType: (type: DeepAnalysisType) => void;
  openChatModal: () => void;
  openVocSearchModal: () => void;
}

export const useDeepAnalysisStore = create<DeepAnalysisStore>()((set) => ({
  isDeepAnalysisModalOpen: false,
  deepAnalysisType: undefined,
  setIsDeepAnalysisModalOpen: (isOpen: boolean) => set(() => ({ isDeepAnalysisModalOpen: isOpen })),
  setDeepAnalysisType: (type: DeepAnalysisType) => set(() => ({ deepAnalysisType: type })),
  openChatModal: () => set(() => ({ isDeepAnalysisModalOpen: true, deepAnalysisType: DeepAnalysisType.CHAT })),
  openVocSearchModal: () =>
    set(() => ({ isDeepAnalysisModalOpen: true, deepAnalysisType: DeepAnalysisType.VOC_SEARCH })),
}));
